import styles from "./styles.module.scss";

import type { IAvatarSize } from "@components/atoms/avatar/types";

export function getSize(size: IAvatarSize) {
  switch (size) {
    case "very-small":
      return styles.verySmall;
    case "small":
      return styles.small;
    case "medium":
      return styles.medium;
    case "large":
      return styles.large;
    default:
      return styles.small;
  }
}
